import React, { Component } from 'react';
import { Container } from 'reactstrap';
import SearchPanel from '@components/SearchPanel/SearchPanel';
import Table from './Table/Table';
import PaginationPanel from '@components/PaginationPanel/PaginationPanel';
import { Helmet } from 'react-helmet';
import * as actions from '@src/store/actions';
import connect from 'react-redux/es/connect/connect';
import LenderModal from './PolicyCarrierModal/PolicyCarrierModal';
import { withRouter } from 'react-router';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import Auth from '@src/components/Elements/Auth/Auth';

class PolicyCarriers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phraze: '',
      modalActive: false
    };

    if (props.list.length === 0) {
      props.getList({}, true);
    }
  }

  componentDidMount = () => {
    document.getElementsByClassName('input-search')[0].click();
    document.getElementsByClassName('input-search')[0].focus();
  };

  onEntityClick = entityId => {
    this.props.history.push(`/carriers/${entityId}`);
  };

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  searchTimeout: null;

  onSearch = value => {
    clearTimeout(this.searchTimeout);
    this.setState({
      phraze: value
    });
    this.searchTimeout = setTimeout(
      () =>
        this.props.getList({
          phraze: value,
          limit: this.props.limit,
          sort: this.props.sort,
          direction: this.props.direction
        }),
      1000
    );
  };

  render = () => {
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | Policy Carriers</title>
        </Helmet>
        <div className={this.props.loaded ? 'position-relative' : 'd-none'}>
          {this.props.loading && (
            <ProgressBox
              text={'Loading ...'}
              loader={'transparent-background'}
            />
          )}
          <h3>Policy Carriers</h3>
          <SearchPanel
            showFilter={false}
            createBtn={false}
            searchValue={this.state.phraze}
            onSearchChange={phraze => this.onSearch(phraze)}
            searchPlaceholder={'Search by Carrier’s name and NAIC #'}
          >
            <Auth action={'Carriers::edit'}>
              <button
                className={'btn btn-primary px-3'}
                onClick={() => this.toggle('modalActive')}
              >
                Create New Carrier
              </button>
            </Auth>
          </SearchPanel>
          <Table
            entities={this.props.list}
            onEntityClick={entityId => this.onEntityClick(entityId)}
            {...this.props}
            paginationFunc={this.props.getList}
            phraze={this.state.phraze}
          />
          <PaginationPanel
            page={this.props.page}
            limit={this.props.limit}
            total={this.props.total}
            start={this.props.start}
            end={this.props.end}
            sort={this.props.sort}
            direction={this.props.direction}
            paginationFunc={this.props.getList}
            phraze={this.state.phraze}
          />
          <LenderModal
            entity={{}}
            history={this.props.history}
            isActive={this.state.modalActive}
            toggle={() => this.toggle('modalActive')}
          />
        </div>
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    list: state.policyCarrier.list,
    page: state.policyCarrier.page,
    limit: state.policyCarrier.limit,
    total: state.policyCarrier.total,
    start: state.policyCarrier.start,
    end: state.policyCarrier.end,
    sort: state.policyCarrier.sort,
    loaded: state.policyCarrier.loaded,
    direction: state.policyCarrier.direction,
    loading: state.policyCarrier.loading
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getList: (getData, hideLoader) =>
      dispatch(actions.getPolicyCarriersList(getData, hideLoader))
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PolicyCarriers)
);
